import { Card } from '@stripe/stripe-js';

export const isExpired = (card: Card): boolean => {
  if (!card) return false;
  const date = new Date(card.exp_year, card.exp_month); // 0th  day of the next month because new Date month is 0 indexed
  return date.getTime() < Date.now();
};

export const expiresSoon = (card: Card): boolean => {
  if (!card) return false;
  const date = new Date(card.exp_year, card.exp_month);
  const now = new Date();
  const diff = date.getTime() - now.getTime();
  const days = diff / (1000 * 60 * 60 * 24);
  return days < 30;
};
